import { any } from 'prop-types';
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import TableSolicitudesPermisosAprobar from '../../DirectivoUnidad/AprobacionSolicitudes/TableSolicitudesPermisosAprobar';
import Cargando from '../../Varios/Cargando';
import { ObtenerInformacionSolicitudesDoctor } from './FunctionAprobacionPermisos';
import { SolicitudesPorAprobar } from './TypesAprobacionPermisos';
import { UserData } from 'components/Sidebar/Sidebar_Principal';
import { authenticationService } from 'services/authentication.service';
import { GetDocumentVistaPrevia } from 'helpers/files';
import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos';

type StateAprobacionSolicitudes = {
    filasTabla: SolicitudesPorAprobar[],
    loadingFilas: boolean,
    errorFilas: boolean,
    mensajeAprobacion: string | undefined,
}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string
}


export default function AprobacionPermisos()
{
    const TITULO_APROBACION_SOLICITUDES = "APROBACIÓN DE SOLICITUD DE PERMISOS ";
    const defaulState: StateAprobacionSolicitudes = {
        filasTabla: [],
        loadingFilas: false,
        errorFilas: false,
        mensajeAprobacion: undefined,
    }

    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {
        loading: false,
        url: ""
    }

    const [stateAprobacion, setstateAprobacion] = useState<StateAprobacionSolicitudes>(defaulState)
    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia)

    async function ObtenerDatosPermisos() {
        setstateAprobacion({ ...stateAprobacion, loadingFilas: true})
        const resultado = await ObtenerInformacionSolicitudesDoctor()
        if (resultado.status === 200) {
            if (typeof (resultado.dataResponse) === "string") {
                setstateAprobacion({ ...stateAprobacion, mensajeAprobacion: resultado.dataResponse, loadingFilas: false })
            }
            else {
                setstateAprobacion({ ...stateAprobacion, filasTabla: resultado.dataResponse, loadingFilas: false})
            }
        }
        else {
            setstateAprobacion({ ...stateAprobacion, loadingFilas: false, errorFilas: true })
        }
    }

    useEffect(() => {
        ObtenerDatosPermisos();

    }, [])

    const onClickVerDoc = useCallback(
        async (referencia: string) => {
            setstateModalVP({ ...stateModalVP, loading: true })
            const datosUsuario: UserData = authenticationService.currentUserValue;
            const url = await GetDocumentVistaPrevia(referencia, datosUsuario.token);
            setstateModalVP({ ...stateModalVP, loading: false, url })
        }, [stateModalVP])


    const tablaSolicitudes = useMemo(() => {
        const { loadingFilas, errorFilas, filasTabla} = stateAprobacion
        if (loadingFilas) {
            return <Cargando mensaje='Cargando Solicitudes' />;
        }
        else if (!loadingFilas && errorFilas) {
            return <div>No ha sido posible cargar la información</div>
        }
        else if (filasTabla.length > 0) {
            return (
                <TableSolicitudesPermisosAprobar
                    dataprops={stateAprobacion.filasTabla}
                    recargarInformacionTabla={() => ObtenerDatosPermisos()}
                    tipoFiltroSolicitud={any}
                    filtrarTiposSolicitud={any}
                    onClickVerDocumento={async (referencia: string) => await onClickVerDoc(referencia)}
                />
            )

        }
        else {
            return (
                <TableSolicitudesPermisosAprobar
                    dataprops={[]}
                    recargarInformacionTabla={() => ObtenerDatosPermisos()}
                    tipoFiltroSolicitud={any}
                    filtrarTiposSolicitud={any}
                    onClickVerDocumento={async (referencia: string) => {;}}
                />
            )
        }

    }, [stateAprobacion])
    return (
        <div className="content">
            <div className="titulo_seccion mb-5"> {TITULO_APROBACION_SOLICITUDES} </div>
            {
                tablaSolicitudes
            }
            <ModalVistaPreviaDocumentos
                cargandoDatos={stateModalVP.loading}
                onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                show={stateModalVP.loading || stateModalVP.url !== ""}
                size="xl"
                tituloModal='Documento de permisos y/o licencias'
                urlArchivo={stateModalVP.url}
                botonCerrar={true}
            />
        </div>
        
    )

}